import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createCustomRule: {
		id: 'servicedesk.automation.summary.add-rule.blueprint-options.create-custom-rule',
		defaultMessage: 'Create a custom rule',
		description: 'Name of a button that user can click to create a custom rule.',
	},
});
